// removed by extract-text-webpack-plugin
module.exports = {"left-column":"domain-form_left-column__2KfhT_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":false,"minimize":true,"localIdentName":"[name]_[local]__[hash:base64:5]_1","importLoaders":1,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/app/dashboard/forms/domain-form.vue
// module id = iqHj
// module chunks = 1